<template>
	<transition name='fade'>
		<div v-if='visiable' class="toast-container" @mousewheel.prevent @touchstart.prevent>
			<div class="content" :style='positionStyle' v-html='content'>
			</div>
		</div>
	</transition>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		name: 'Toast',
		data() {
			return {
				content:'',
				visiable:false,
				position:'top',
				type:'tip',
				defaultConfig:{
					duration:3000,
					position:'center'
				}
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
			positionStyle(){
				switch(this.position){
					case 'top':
						return {
							top:'100px'
						}
					case 'center':
						return {
							
						}
					case 'bottom':
						return {
							bottom:'30px'
						}
				}
				return null
			}
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			show(content,config){
				config = Object.assign(this.defaultConfig,config)
				this.type = 'tip'
				this.content = content;
				this.visiable = true
				this.position = config.position
				setTimeout(()=>{
					this.visiable = false
				},config.duration)
			},
			hide(){
				this.visiable = false
			},
			loading(content,config){
				config = Object.assign(this.defaultConfig,config)
				this.type = 'loading'
				this.content = content;
				this.visiable = true
				this.position = config.position
				// setTimeout(()=>{
				// 	this.visiable = false
				// },config.duration)
			}
		},
	}
</script>

<style lang='scss' scoped>
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
	.toast-container {
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 9999;
		background-color: rgba(0,0,0,0.05);
		display: flex;
		justify-content: center;
		align-items: center;
		.content {
			position: fixed;
			padding: 8px 15px;
			border-radius: 4px;
			background-color: rgba(0,0,0,0.5);
			color: white;
			max-width: 500px;
			text-align: center;
			margin: auto;
			font-size: 14px;
			line-height: 24px;

			top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
            -moz-transform: translate(-50%, -50%);

		}
	}
	
</style>